const AUTH_ERROR_MESSAGE_PATTERNS = [
  'a token was not provided',
  'token expired',
  'token invalid',
  'unauthenticated',
  'you have been logged out due to inactivity',
  'your session has expired',
  'your session was expired',
]

let loginRedirectPromise = null

export const AUTH_EXPIRED_MESSAGE = 'Please log in again.'

export const isNoTokenError = (error) => error?.message === 'NO_TOKEN_FOUND'

export const getAuthErrorMessage = (error) => {
  let message = error?.response?.data?.data || error?.message || ''

  if (typeof message === 'object') {
    message = Object.values(message)[0] || ''
  }

  return Array.isArray(message) ? message[0] || '' : `${message}`
}

export const isAuthExpiredError = (error) => {
  if (isNoTokenError(error)) {
    return true
  }

  const status = error?.response?.status
  const message = getAuthErrorMessage(error).toLowerCase()
  const matchesAuthMessage = AUTH_ERROR_MESSAGE_PATTERNS.some((pattern) => message.includes(pattern))

  if (status === 498) {
    return true
  }

  return matchesAuthMessage
}

export const shouldRefreshAuthError = (error) => {
  const status = error?.response?.status

  if (status === 498) {
    return true
  }

  return status === 401 && isAuthExpiredError(error)
}

export const routeRequiresAuth = (route) => {
  return route?.matched?.some((matchedRoute) => matchedRoute.meta.authRequired)
}

export const getLoginReturnUrl = (router) => {
  const route = router?.currentRoute

  if (route?.name && route.name !== 'login') {
    return route.fullPath
  }

  const currentPath = window.location.pathname + window.location.search
  return currentPath.length > 1 && currentPath !== '/login' ? currentPath : ''
}

export const redirectToLoginForAuth = async (
  store,
  router,
  returnUrl = getLoginReturnUrl(router),
  { showMessage = true } = {}
) => {
  if (loginRedirectPromise) {
    return loginRedirectPromise
  }

  loginRedirectPromise = (async () => {
    if (showMessage) {
      store.commit('auth/SET_ADMIN_AUTH_ERROR', AUTH_EXPIRED_MESSAGE)
    }
    await store.dispatch('auth/logOut')

    if (router?.currentRoute?.name === 'login') {
      return
    }

    const route = returnUrl ? { name: 'login', query: { returnUrl } } : { name: 'login' }
    await router.push(route).catch((error) => {
      if (error?.name === 'NavigationDuplicated') {
        return
      }

      throw error
    })
  })()

  try {
    await loginRedirectPromise
  } finally {
    loginRedirectPromise = null
  }
}
